// `head` opens the source: surfaceFragment rewrites these exact lines, and every stage reads what they declare.
export default {
	ids: [],
	head: `in vec2 vUV;
out vec4 fragColor;
uniform vec2 uResolution;
uniform vec4 uColor;
uniform float uStageUnit;
`,
	glsl: `
void main() {
	Ray ray = camera(vUV);
	Surf s = surface(ray);
	float h = displacement(s);
	s = relief(ray, s);
	Cell c = lattice(s, h);
	vec4 col = light(profile(c, h), s, c);
	fragColor = col * uColor * s.hit;
}
`,
	// SCAFFOLD (common.js `scaffoldVariant`) replaces `glsl`: a line where palette's band code steps between a pixel and its right or lower neighbour.
	scaffold: {
		glsl: `
vec4 scaffoldCode() {
	Ray ray = camera(scaffoldUV);
	Surf s = surface(ray);
	float h = displacement(s);
	s = relief(ray, s);
	Cell c = lattice(s, h);
	return light(profile(c, h), s, c) * s.hit;
}

void main() {
	vec2 uv = vUV;
	scaffoldUV = uv;
	vec4 q = scaffoldCode();
	scaffoldUV = uv + dFdx(uv);
	vec4 qx = scaffoldCode();
	scaffoldUV = uv + dFdy(uv);
	vec4 qy = scaffoldCode();
	vec4 d = max(abs(qx - q), abs(qy - q));
	float line = smoothstep(0.04, 0.2, max(max(d.r, d.g), max(d.b, d.a)));
	fragColor = vec4(vec3(1.0 - line), 1.0) * uColor;
}
`,
	},
	// PICK: lattice's `pat` on axis PICK (0 line, 1 along) in RGB8, 12 bits whole mod 4096 and 12 fraction, alpha the hit; only the pick variant (`src/lib/drag/pick.js`) carries it.
	pick: {
		at: 'fragColor = col * uColor * s.hit;',
		glsl: `float pickCell = PICK == 0 ? pat.line : pat.along;
	float pickHit = pat.hit;
	float pickWhole = mod(floor(pickCell), 4096.0);
	float pickFrac = min(floor(fract(pickCell) * 4096.0), 4095.0);
	fragColor = vec4(floor(pickWhole / 16.0), mod(pickWhole, 16.0) * 16.0 + floor(pickFrac / 256.0), mod(pickFrac, 256.0), 255.0 * pickHit) / 255.0;`,
	},
}
